import { BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface TimekeepingActionSuccessContentProps {
  title: string;
  description?: string;
  onClose: () => void;
}

export function TimekeepingActionSuccessContent(props: TimekeepingActionSuccessContentProps) {
  const { title, description, onClose } = props;

  return (
    <Box>
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="clock"
        title={title}
        description={description}
      />
      <DialogFooter orientation="vertical" closeButtonAriaLabel="Close" onClose={onClose} />
    </Box>
  );
}
